import SgdfTeamParticipantList from './team-participant-list.component.js';
export * from './team-participant-list.component.js';
export default SgdfTeamParticipantList;
SgdfTeamParticipantList.define('sgdf-team-participant-list');
//# sourceMappingURL=team-participant-list.js.map